import { useMemo } from 'react';

import adminProductLabelTemplateService from '@services/admin/productLabelTemplateService';

/**
 * Admin Product Label Template Service Hook
 *
 * Simple wrapper for adminProductLabelTemplateService
 *
 * @returns {Object} productLabelTemplateService
 *
 * @example
 * const productLabelTemplateService = useAdminProductLabelTemplateService();
 *
 * await productLabelTemplateService.create({ name: 'Label Template A', content: '...' });
 * await productLabelTemplateService.getById(1);
 */
export default function useAdminProductLabelTemplateService() {
  return useMemo(() => adminProductLabelTemplateService, []);
}
